import { render, staticRenderFns } from "./PreorderedMenu.vue?vue&type=template&id=226aee87&scoped=true&"
import script from "./PreorderedMenu.vue?vue&type=script&lang=js&"
export * from "./PreorderedMenu.vue?vue&type=script&lang=js&"
import style0 from "./PreorderedMenu.vue?vue&type=style&index=0&id=226aee87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226aee87",
  null
  
)

export default component.exports